// Port of SuiteModel/QuoteSearch.swift: finds quoted text in a fragment's text, in Unicode scalars (Automerge positions),
// for anchoring comments by what they quote (agents, merges, re-imports).

/** `QuoteSearch.occurrences(of:in:)`: every place `quote` occurs in `text`, in order (overlapping starts included). */
export function occurrences(quote: string, text: string): [number, number][] {
  const hay = [...text], needle = [...quote];
  if (!needle.length || needle.length > hay.length) return [];
  const out: [number, number][] = [];
  outer: for (let i = 0; i + needle.length <= hay.length; i++) {
    for (let j = 0; j < needle.length; j++) if (hay[i + j] !== needle[j]) continue outer;
    out.push([i, i + needle.length]);
  }
  return out;
}

/** `QuoteSearch.nearest(_:to:in:)`: the occurrence nearest to `hint` (where it was in another version of the text). */
export function nearest(quote: string, hint: number, text: string): [number, number] | null {
  let best: [number, number] | null = null;
  for (const hit of occurrences(quote, text)) if (!best || Math.abs(hit[0] - hint) < Math.abs(best[0] - hint)) best = hit;
  return best;
}
